export const INFO : IPackageTeaserCardList = {
    headline: '',
    cards: []
}
